import { render } from "./Consultation.vue?vue&type=template&id=378b37b2"
const script = {}

import exportComponent from "/home/mbenson/Projects/bottll/customer/dan-chitwood/chitwood-landscape-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__